const GUEST_PREVIEW_AUTH_PATCH = Symbol.for('eInvitation.photoAlbumGuestPreviewAuth.v1')

function normalizeAlbumId(value) {
  return String(value || '')
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/[_\s]+/g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase()
}

function getCurrentAlbumId() {
  const match = window.location.pathname.match(/\/e-photo-album\/([^/?#]+)/i)
  return normalizeAlbumId(match ? decodeURIComponent(match[1]) : '')
}

function getStoredGuestToken(albumId) {
  try {
    return window.localStorage.getItem(`ephoto_guest_token_${albumId}`) || ''
  } catch {
    return ''
  }
}

function parseRequestUrl(input) {
  try {
    const value = typeof input === 'string' || input instanceof URL
      ? String(input)
      : input?.url
    return new URL(value, window.location.href)
  } catch {
    return null
  }
}

function isGuestOwnedPhotoRequest(url) {
  return Boolean(url && /\/(?:api\/)?photo-albums\/[^/]+\/my-uploads(?:\/|$)/i.test(url.pathname))
}

export function installPhotoAlbumGuestPreviewAuth() {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function' || globalThis[GUEST_PREVIEW_AUTH_PATCH]) return

  const albumId = getCurrentAlbumId()
  if (!albumId) return

  const previousFetch = window.fetch.bind(window)

  window.fetch = (input, init = {}) => {
    const url = parseRequestUrl(input)
    if (!isGuestOwnedPhotoRequest(url)) return previousFetch(input, init)

    const isRequest = typeof Request !== 'undefined' && input instanceof Request
    const headers = new Headers(init.headers || (isRequest ? input.headers : undefined))
    const token = getStoredGuestToken(albumId)

    if (token && !headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`)
    }

    return previousFetch(input, {
      ...init,
      headers,
      credentials: 'include',
    })
  }

  globalThis[GUEST_PREVIEW_AUTH_PATCH] = true
}
